import AppDispatcher from '@reducers/app/dispatcher';
import _ from 'lodash';
import CompaniesDispatcher from '../companies/dispatcher';
import { mapSearchCompanyToCompany } from '../companies/mappers';
import { actions as companiesActions } from '../companies/reducer';
import ContactsDispatcher from '../contacts/dispatcher';
import { getContactMapKey, mapEmployeeToContact } from '../contacts/mappers';
import { actions } from './reducer';
class Dispatcher {
    constructor() {
        this.actions = Object.assign(Object.assign({}, actions), { setListId: companiesActions.setListId });
    }
    fetchCompanyLid(company) {
        return CompaniesDispatcher.fetchCompanyLid(company);
    }
    setSearchEmployeesResult(result) {
        return dispatch => {
            dispatch(actions.setSearchEmployeesResult(result));
            const { contacts, company } = result || {};
            if (_.isEmpty(company)) {
                dispatch(AppDispatcher.actions.setAppDataState('empty'));
            }
            else {
                const mappedCompany = mapSearchCompanyToCompany(company);
                if (mappedCompany) {
                    dispatch(CompaniesDispatcher.setCompanies([mappedCompany]));
                }
            }
            if (contacts === null || contacts === void 0 ? void 0 : contacts.length) {
                const mappedContacts = result.contacts.map(employee => {
                    var _a, _b;
                    return mapEmployeeToContact(employee, {
                        requestId: result.requestId,
                        companyLid: (_b = (_a = result.company) === null || _a === void 0 ? void 0 : _a.company_lid) !== null && _b !== void 0 ? _b : null,
                        companyName: (company === null || company === void 0 ? void 0 : company.name) || '',
                    });
                });
                dispatch(ContactsDispatcher.setContacts(mappedContacts));
                dispatch(actions.setEmployeeIds(mappedContacts.map(getContactMapKey)));
            }
        };
    }
    clearSearchEmployeesResult() {
        return dispatch => {
            dispatch(actions.clearSearchEmployeesResult());
        };
    }
}
const CompanyDispatcher = new Dispatcher();
export default CompanyDispatcher;
